module.exports = __webpack_public_path__ + "img/03-ui-toc-mockup.2c00237f.webp";